import { IMPORT_DESCRIPTOR_TYPE } from '../../../../../../constants/generalConstants';
import { ImportDescriptorDataTypeType } from '../../../../../../types';

type GetSelectTypeStylingReturnType = {
    classes: string;
};

export function getSelectTypeStyling(type: ImportDescriptorDataTypeType): GetSelectTypeStylingReturnType {
    let classes = 'select select__types';
    if (type === IMPORT_DESCRIPTOR_TYPE.ANY) {
        classes = `${classes} bg-yellow`;
    } else {
        classes = `${classes} bg-grey`;
    }

    return { classes };
}
